import { languageConfig } from "i18n/language-config";
import { NextPage } from "next";
import { loadServerTranslations } from "../../i18n/messages";
import { INextPageProps } from "../../app";
import { useTranslations } from "next-intl";
import Seo from "domain/SeoAndAnalytics/Seo";
import { frontendUrlBuilder } from "../../utils/routing/frontend-url-builder";
import { useRouter } from "next/router";
import { TermsAndConditionsHubContent } from "domain/TermsAndConditions/TermsAndConditionsHubContent/TermsAndConditionsHubContent";

interface Props extends INextPageProps {}

const TermsAndConditionsHub: NextPage<Props> = () => {
  const t = useTranslations("page-terms-conditions-hub");
  const router = useRouter();

  return (
    <>
      <Seo
        title={t("seo.metaTitle")}
        description={t("seo.metaDescription")}
        canonical={frontendUrlBuilder.buildCanonicalUrl(router.asPath)}
      />
      <TermsAndConditionsHubContent />
    </>
  );
};

export const getStaticProps = async ({ params: { lang = null } = {} }) => {
  if (!languageConfig.isLanguageAllowedInPath(lang)) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }

  const locale = languageConfig.mapLanguageToLocale(lang);

  return {
    props: {
      locale,
      messages: await loadServerTranslations(locale, ["common", "page-terms-conditions-hub"]),
    },
    revalidate: 60,
  };
};

export async function getStaticPaths() {
  const langs = languageConfig.getLanguages();
  const paths = langs
    .filter((lang) => lang != "en")
    .map((lang) => ({
      params: { lang },
    }));
  return { paths, fallback: true };
}

export default TermsAndConditionsHub;
